import { type FC, type ReactNode } from 'react';
import { Card, Space } from 'antd';
import styles from 'pages/homeDashboard/styles.module.scss';

type DashboardContentProps = {
  children?: ReactNode;
};

const DashboardContent: FC<DashboardContentProps> = ({ children }) => (
  <div className={styles.content} role="main">
    <Space direction="vertical" className={styles['content-stack']}>
      {children ?? (
        <Card
          title="Sample"
          variant="borderless"
          className={styles['content-card']}
        />
      )}
    </Space>
  </div>
);

export default DashboardContent;
